import { graphql, useStaticQuery } from 'gatsby';

const useScienceData = () => {
  const { contentfulPage } = useStaticQuery(graphql`
    query {
      contentfulPage(pageId: { eq: "Science" }) {
        title
        faqSchema {
          question
          answer
        }
        topBanner {
          headline
          mainCta {
            text
            url
          }
        }
        heroSection {
          componentName
          headline
          description
          desktopImage {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75, width: 1653)
          }
          mobileImage {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          mainCta {
            text
            url
          }
          secondaryHeadline
          secondaryCtaList {
            text
            url
          }
          listOfContentWithImages {
            heading
            image {
              description
              gatsbyImageData(placeholder: BLURRED, width: 164, quality: 75)
            }
          }
          backgroundColor
        }
        sections {
          sectionId
          componentName
          componentVariation
          title
          slug
          headline
          subHeadline
          description {
            childMarkdownRemark {
              html
            }
            description
          }
          subHeadlineDescription {
            childMarkdownRemark {
              html
            }
            subHeadlineDescription
          }
          mainCta {
            text
            url
            appearance
          }
          listOfContentWithImages {
            heading
            subheading
            title
            description {
              childMarkdownRemark {
                html
              }
              description
            }
            image {
              description
              gatsbyImageData(placeholder: BLURRED, width: 414, quality: 75)
            }
            cta {
              text
              url
              appearance
            }
            subheading
            number
            identifier
            featureFlag
          }
          desktopImages {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          mobileImages {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          listOfLinks {
            text
            url
          }
          backgroundColor
        }
      }
    }
  `);

  return contentfulPage;
};
export default useScienceData;
